<script>
  import BrandLayout from '../components/Layout'
  import { brandComputed } from '@store/helpers'

  export default {
    page() {
      return {
        title: `${this.currentBrand.title}`,
      }
    }, 
    components: {
      BrandLayout,
    },
    data() {
      return {
        type: 'introduce',
        // courseList: COURSE_LIST,
      }
    },
    computed: {
      ...brandComputed,
    },
    methods: {
      
      /* checkCanDownload(list) {
        const result = list.filter((item) => {
          return item.canDownload
        });

        if(result.length > 3) {
          result.length = 3
        }

        return result
      }, */
    }
  }
</script>
<template>
  <BrandLayout>
    <div class="section container">
      <template v-if="currentBrand">
        <div class="text-3xl text-center mb-4 font-medium">{{ currentBrand.title }}</div>
        <div 
          v-if="currentBrand.description" 
          style="line-height: 2" 
          class="article"
          v-html="currentBrand.description"
          >
        </div>
      </template>
      <template v-else>
        <BaseNull
          content="<p class='my-0'>目前此頁面無資料</p> <p class='mb-0 mt-3'>點擊下方按鈕，探索更多資訊</p>"
        >
          <BaseButton
            class="isStylePrimary isCol4 isRadius mt-5"
            :to="{ name: 'brand-item', params: { brandAlias: $rotue.params.brandAlias } }"
          >
            探索更多資訊
          </BaseButton>
        </BaseNull>
      </template>
    </div>
  </BrandLayout>
</template>